<template>
  <div class="d-flex flex-column ga-5">
  <GoogleLoginBtn @registration-required="(r) => {this.needsRegistration=true;this.provider='google'; this.token=r.token}"/>
  <LinkedInBtn @registration-required="(r) => {this.needsRegistration=true;this.provider='linkedIn'; this.token=r.token}"/>
  </div>
  <v-dialog v-model="needsRegistration">
    <PromptIndividualOrBusiness @update="completeRegistration" :options="options"/>
    <v-dialog persistent v-model="addCompany">
      <v-card>
        <v-card-text>
          <CompanyInfoForm v-model:valid="companyValid" :commercial="true" v-model:company="companyRequest"/>
        </v-card-text>
        <v-card-actions>
          <v-btn variant="plain" @click="cancel">{{$t('buttons.cancel')}}</v-btn>
          <v-btn :loading="loading" color="accent" variant="text" :disabled="!companyValid" @click="createAccountBusiness">{{$t('buttons.continue')}}</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-dialog>

</template>

<script>
import {GoogleLogin} from "vue3-google-login";
import {useAuthUserStore} from "@/stores/modules/auth.module";
import PromptIndividualOrBusiness from "@/components/auth/PromptIndividualOrBusiness.vue";
import {useNotificationStore} from "@/stores/notification.module";
import CompanyInfoForm from "@/components/auth/CompanyInfoForm.vue";
import {company} from "@/models/auth/businessUserRegister";
import GoogleLoginBtn from "@/components/auth/socialLogin/GoogleLoginBtn.vue";
import LinkedInBtn from "@/components/auth/socialLogin/LinkedInBtn.vue";

export default {
  name: 'SocialLoginWrapper',
  setup() {
    const authStore = useAuthUserStore();
    const notificationStore = useNotificationStore();
    return {
      authStore,
      notificationStore
    }
  },
  components: {LinkedInBtn, GoogleLoginBtn, CompanyInfoForm, PromptIndividualOrBusiness, GoogleLogin},
  computed:{
  },
  data(){
    return {
        provider:null,
        token:null,
      loading:false,
      companyValid:false,
      needsRegistration:false,
      addCompany:false,
      companyRequest: new company(),
      options:[
        {text:'private',value:'individual'},
        {text:'business',value:'business'}
      ],
    }
  },
  methods: {
    async completeRegistration(option){
      if(option.value === 'business'){
        this.addCompany=true;
      }
      else{
        await this.createAccount(option);
      }
    },
    cancel(){
      this.addCompany=false;
      this.needsRegistration=false;
    },
    createAccountBusiness(){
      this.createAccount({value:'business'});
    },
    async createAccount(option){
      this.loading=true;
      if(!this.token){
        console.log("No token found");
        this.notificationStore.pushSimple("Error receiving token | Try logging in again", "ERROR");
        return;
      }
      if(!this.provider){
        console.log("No provider found");
        this.notificationStore.pushSimple("Error receiving provider | Try logging in again", "ERROR");
        return;
      }
      const data = await this.authStore.loginSocials(this.provider, {
        token: this.token,
        typeOfAccount: option.value,
        companyRequest: this.companyRequest
      });
      this.loading=false;
    },
  }
}
</script>